module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }